import React from 'react';

import VerifyPhoneForm from '@components/forms/verifyPhone';

import useVerifyPhone from './hooks';

function VerifyPhone({ onSuccess, onDecline }: { onSuccess?: () => void; onDecline?: () => void }) {
	const { initialValues, onSubmit } = useVerifyPhone({ onSuccess });

	return <VerifyPhoneForm initialValues={initialValues} onDecline={onDecline} onSubmit={onSubmit} />;
}

export default VerifyPhone;
